<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 施工信息</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="施工人员" prop="work_id">
                                        <Select v-model="Forms.work_id" filterable clearable multiple placeholder="施工人员">
                                            <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="开工日期" prop="start_work_time">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.start_work_time" placeholder="开工日期" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="预计工期" prop="work_duration">
                                        <Input v-model="Forms.work_duration" clearable placeholder="如：6个月" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="预计完工日期" prop="work_expected_time">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.work_expected_time" placeholder="预计完工日期" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="备注信息" prop="remark">
                                        <Input v-model="Forms.remark" type="textarea" :rows="8" clearable placeholder="备注信息" />
                                        <small class="text-danger">提示：请勿删除原有备注信息</small>
                                    </FormItem>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认施工</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {workTrueProject, getProjectConfig, getProjectContentDetail} from "@/apis/project";

export default {
    name: 'ProjectWorkTrue',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '开始施工',
            isBox : false,
            userList: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                project_id: '',
                work_id: [],
                start_work_time: '',
                work_duration: '',
                work_expected_time: '',
                remark: '',
            },
            Rules : {
                work_id: [
                    { required: true, type: 'array', min: 1,  message: '请选择施工人员', trigger: 'change' }
                ],
                start_work_time: [
                    { required: true, type:'date',  message: '请选择开工日期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectContentDetail(project_id).then(e => {
                let re = e.data;
                that.Forms.work_id = re.work_id ? re.work_id : [];
                that.Forms.start_work_time = re.start_work_time ? re.start_work_time : '';
                that.Forms.work_duration = re.work_duration ? re.work_duration : '';
                that.Forms.work_expected_time = re.work_expected_time ? re.work_expected_time : '';
                that.Forms.remark = re.remark ? re.remark : '';
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 开始施工';
            if(project_id){
                this.getConfig();
                this.Forms.project_id = project_id;
                this.GetDetail(project_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    workTrueProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '开始施工';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
